import { useMemo } from 'react';

type Position = 'top' | 'bottom';

export const usePosition = (): Position => {
  return useMemo(() => {
    if (typeof window === 'undefined') return 'top'; // default for SSR safety

    const params = new URLSearchParams(window.location.search);
    const raw = params.get('position');

    return raw === 'bottom' ? 'bottom' : 'top'; // default to top if invalid
  }, []);
};

export default usePosition;
